import { schema, types } from 'papr'

export const rssIntegrationSchema = schema(
	{
		user: types.objectId({ required: true }),
		publication: types.objectId({ required: true }),
		dateAdded: types.date(),
		dateUpdated: types.date(),
		url: types.string(),
		rssTagName: types.string(),
		lastPolledAt: types.date(),
		importAsDrafts: types.boolean(),
		scrapePosts: types.boolean(),
		isActive: types.boolean(),
	},
	{
		defaults: {
			rssTagName: 'content:encoded',
			importAsDrafts: false,
			scrapePosts: false,
			isActive: true,
		},
	},
)

export type RSSIntegrationDocument = (typeof rssIntegrationSchema)[0]
export type RSSIntegrationSchemaOptions = (typeof rssIntegrationSchema)[1]
